import React from "react";
import Nav from "./Nav";
import ProcessSection from "./ProcessSection";
import FinalCTA from "./FinalCTA";
import Footer from "./Footer";

const ProcessPage = () => (
  <div className="App">
    <title>Our Process — EffiGen LLC</title>
    <meta
      name="description"
      content="Learn how EffiGen LLC takes AI projects from idea to production: Discover, Prototype, Engineer, Deploy, and Lifecycle."
    />
    <link rel="canonical" href="https://effigen.ai/process" />
    <Nav />
    <main>
      <ProcessSection />
      <FinalCTA />
    </main>
    <Footer />
  </div>
);

export default ProcessPage;
